<script setup>
// история загрузок отдельного документа
// список загружаем, чтобы связать номер (route.params.id) и название
import AppDocWithSignature from "@/components/Admin/Tabs/AppDocWithSignature";
import {ref, computed, onMounted} from 'vue'
import {useStore} from "vuex";
import axios from "axios";
import {useRoute} from "vue-router";
//----------------------------------------------------------------------
const store = useStore()
const route = useRoute()
const docs = ref(store.getters['docsModule/documents'])
const docName = ref('')
onMounted( ()=>{
  init()
})

const init = async () => {
  store.commit('menuModule/initMenu')

  // если страница была перегружена, то делаем запрос
  // по умолчанию данные из store
  if (docs.value.length === 0) {

    const urlDocs = process.env.VUE_APP_API + 'upload-docs.php'
    await axios
        .get(`${urlDocs}?token=${token.value}`)
        .then(response => (docs.value = response.data))
        .catch(error => alert(error));

  }

  //console.log(route.params.id)
  //let a = docs.value.find(item => item.list.docs[1] == route.params.id);
  //console.log(a)

  docs.value.forEach(function(item) {
    item['list'].forEach(function(item) {
      item['docs'].forEach(function(item) {
        if (item[1] === route.params.id){
          docName.value = item[0]
          return
        }
      })
    })
  });

}
//----------------------------------------------------------------------
const token = computed( () => {return store.getters['authModule/token']})
</script>

<template>
  <main class="content-wrapper">
    <AppDocWithSignature
        v-if="docName"
        :title="docName"
        :section="route.params.id"
    ></AppDocWithSignature>
  </main>
</template>